export const isBase64Encoded = (str: string) => {
   try {
      return btoa(atob(str)) === str;
   } catch (err) {
      return false;
   }
};
